import { BaseQuantity } from "../../interface/functionalityInterface";
// unitless
export const UnitLess: BaseQuantity = {
  id: "001unitless",
  name: "",
  type: "numeric",
  value: "",
  symbol: "",
  baseUnit: "",
  selectedUnit: "",
  units: [{ name: "", fromConst: 1, toConst: 1 }],
};
